<template>
  <div class="relative">
    <div
      class="rounded-full w-7 h-7 flex items-center justify-center bg-neutral-900 text-xs font-semibold text-white cursor-pointer"
    >
      {{ initial }}
    </div>
    <span
      v-if="unreadMessageCount > 0"
      class="absolute -top-1 -right-1 w-3 h-3 bg-red-500 rounded-full border-2 border-white shadow-sm"
      aria-hidden="true"
    />
    <span v-if="unreadMessageCount > 0" class="sr-only">
      {{ unreadMessageCount }} unread messages
    </span>
    <span
      v-if="hasUnseenReadyExport"
      class="absolute -bottom-1 -right-1 w-3 h-3 bg-green-500 rounded-full border-2 border-white shadow-sm"
      aria-hidden="true"
    />
    <span v-if="hasUnseenReadyExport" class="sr-only">An export is ready to download</span>
  </div>
</template>

<script>

import {mapGetters} from 'vuex'

export default {
  computed:{
    ...mapGetters('auth',['current_user', 'unreadMessageCount']),
    ...mapGetters('exports', { hasUnseenReadyExport: 'hasUnseenReady' }),
    initial() {
      if (this.current_user?.first_name && this?.current_user.last_name) {
        return this.current_user.first_name.charAt(0) + this.current_user.last_name.charAt(0)
      }
      return ''
    }
  },
}
</script>

<style>
.hidden {
  display: none;
}
</style>
